export const state = {
  productsFilters: {},
  productsSorting: {},
  articlesFilters: {},
  articlesSorting: {},
  selectedProductsFilters: [],
  selectedProductsFiltersIds: [],
  selectedArticlesFilters: [],
  selectedArticlesFiltersIds: [],
  isLoadingFilters: false
};

export const mutations = {
  setProductsFilters(state, payload) {
    state.productsFilters = payload;
    state.productsFilters.filters.forEach(filter => {
      const selectedFilter = state.selectedProductsFiltersIds.find(element => element.category === filter.id);
      filter.options.forEach(option => {
        option.selected = selectedFilter && selectedFilter.tags.indexOf(option.id) >= 0;
      });
    });
  },
  setArticlesFilters(state, payload) {
    state.articlesFilters = payload;
    state.articlesFilters.filters.forEach(filter => {
      const selectedFilter = state.selectedArticlesFiltersIds.find(element => element.category === filter.id);
      filter.options.forEach(option => {
        option.selected = selectedFilter && selectedFilter.tags.indexOf(option.id) >= 0;
      });
    });
  },
  selectProductsFiltersOption(state, payload) {
    const filter = state.selectedProductsFiltersIds.find(element => element.category === payload.filterId);
    if (filter) {
      state.selectedProductsFiltersIds[state.selectedProductsFiltersIds.indexOf(filter)].tags.push(payload.selectedOptionId);
    } else {
      state.selectedProductsFiltersIds.push(
        {
          category: payload.filterId,
          tags: [payload.selectedOptionId]
        }
      );
    }

    if (!state.selectedProductsFilters.find(filter => filter.selectedOptionId === payload.selectedOptionId)) {
      state.selectedProductsFilters.push({
        filterId: payload.filterId,
        selectedOptionId: payload.selectedOptionId,
        title: state.productsFilters.filters.find(e => e.id === payload.filterId).options.find(option => option.id === payload.selectedOptionId).title
      });
    }
  },
  unselectProductsFiltersOption(state, payload) {
    let filter = state.selectedProductsFiltersIds.find(element => element.category === payload.filterId);
    if (!filter || filter.tags.indexOf(payload.selectedOptionId) < 0) {
      return;
    }
    filter.tags.splice(filter.tags.indexOf(payload.selectedOptionId), 1);
    if (filter.tags.length <= 0) {
      state.selectedProductsFiltersIds.splice(state.selectedProductsFiltersIds.indexOf(filter), 1);
    }

    filter = state.selectedProductsFilters.find(filter => filter.selectedOptionId === payload.selectedOptionId);
    if (filter) {
      state.selectedProductsFilters.splice(state.selectedProductsFilters.indexOf(filter), 1);
    }
  },
  selectArticlesFiltersOption(state, payload) {
    const filter = state.selectedArticlesFiltersIds.find(element => element.category === payload.filterId);
    if (filter) {
      state.selectedArticlesFiltersIds[state.selectedArticlesFiltersIds.indexOf(filter)].tags.push(payload.selectedOptionId);
    } else {
      state.selectedArticlesFiltersIds.push(
        {
          category: payload.filterId,
          tags: [payload.selectedOptionId]
        }
      );
    }

    if (!state.selectedArticlesFilters.find(filter => filter.selectedOptionId === payload.selectedOptionId)) {
      state.selectedArticlesFilters.push({
        filterId: payload.filterId,
        selectedOptionId: payload.selectedOptionId,
        title: state.articlesFilters.filters.find(e => e.id === payload.filterId).options.find(option => option.id === payload.selectedOptionId).title
      });
    }
  },
  unselectArticlesFiltersOption(state, payload) {
    let filter = state.selectedArticlesFiltersIds.find(element => element.category === payload.filterId);
    if (!filter || filter.tags.indexOf(payload.selectedOptionId) < 0) {
      return;
    }

    filter.tags.splice(filter.tags.indexOf(payload.selectedOptionId), 1);
    if (filter.tags.length <= 0) {
      state.selectedArticlesFiltersIds.splice(state.selectedArticlesFiltersIds.indexOf(filter), 1);
    }

    filter = state.selectedArticlesFilters.find(filter => filter.selectedOptionId === payload.selectedOptionId);
    if (filter) {
      state.selectedArticlesFilters.splice(state.selectedArticlesFilters.indexOf(filter), 1);
    }
  },
  clearSelectedArticlesFilters(state) {
    state.selectedArticlesFilters = [];
    state.selectedArticlesFiltersIds = [];
    state.productsFilters.filters.forEach(productFilter => {
      productFilter.options.forEach(option => {
        option.selected = false;
      });
    });
  },
  clearSelectedProductsFilters(state) {
    state.selectedProductsFilters = [];
    state.selectedProductsFiltersIds = [];
    state.articlesFilters.filters.forEach(articleFilter => {
      articleFilter.options.forEach(option => {
        option.selected = false;
      });
    });
  },
  setIsLoadingFilters(state, payload) {
    state.isLoadingFilters = payload;
  },
  setArticlesSorting(state, payload) {
    state.articlesSorting = payload;
  },
  selectArticlesSortingOption(state, payload) {
    state.articlesSorting.selectedOption = payload;
  },
  setProductsSorting(state, payload) {
    state.productsSorting = payload;
  },
  selectProductsSortingOption(state, payload) {
    state.productsSorting.selectedOption = payload;
  }
};

export const actions = {
  setProductsFilters({ commit }, payload) {
    commit('setProductsFilters', payload);
  },
  setArticlesFilters({ commit }, payload) {
    commit('setArticlesFilters', payload);
  },
  selectProductsFiltersOption({ commit }, payload) {
    commit('selectProductsFiltersOption', payload);
  },
  unselectProductsFiltersOption({ commit }, payload) {
    commit('unselectProductsFiltersOption', payload);
  },
  selectArticlesFiltersOption({ commit }, payload) {
    commit('selectArticlesFiltersOption', payload);
  },
  unselectArticlesFiltersOption({ commit }, payload) {
    commit('unselectArticlesFiltersOption', payload);
  },
  clearSelectedArticlesFilters({ commit }) {
    commit('clearSelectedArticlesFilters');
  },
  clearSelectedProductsFilters({ commit }) {
    commit('clearSelectedProductsFilters');
  },
  setIsLoadingFilters({ commit }, payload) {
    commit('setIsLoadingFilters', payload);
  },
  setArticlesSorting({ commit }, payload) {
    commit('setArticlesSorting', payload);
  },
  selectArticlesSortingOption({ commit }, payload) {
    commit('selectArticlesSortingOption', payload);
  },
  setProductsSorting({ commit }, payload) {
    commit('setProductsSorting', payload);
  },
  selectProductsSortingOption({ commit }, payload) {
    commit('selectProductsSortingOption', payload);
  }
};

export const getters = {
  productsFilters: (state) => state.productsFilters,
  productsSorting: (state) => state.productsSorting,
  selectedProductsSorting: (state) => state.productsSorting.selectedOption,
  productsCount: (state) => state.productsFilters.count,
  articlesFilters: (state) => state.articlesFilters,
  articlesSorting: (state) => state.articlesSorting,
  selectedArticlesSorting: (state) => state.articlesSorting.selectedOption,
  articlesCount: (state) => state.articlesFilters.count,
  selectedProductsFiltersIds: (state) => state.selectedProductsFiltersIds,
  selectedArticlesFiltersIds: (state) => state.selectedArticlesFiltersIds,
  isLoadingFilters: (state) => state.isLoadingFilters,
  selectedProductsFilters: (state) => state.selectedProductsFilters,
  selectedArticlesFilters: (state) => state.selectedArticlesFilters
};

export default  {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
